import { BUDGETING_READ } from '../budgetingService';
import ServiceCostsStructureRecordLayout from './ServiceCostsStructureRecordLayout';
import { TimelineItem } from 'framework/ui/timeline';
import CreateServiceCostsStructure from './Create';
import UpdateServiceCostsStructure from 'domain/organization/serviceCatalog/budgets/structure/Update';

const useServiceCostsStructureRegistry = () => ({
  AddForm: CreateServiceCostsStructure,
  UpdateForm: UpdateServiceCostsStructure,
  RecordLayout: ServiceCostsStructureRecordLayout,
  isApplicable: (item: TimelineItem) => item,
  source: '',
  urlPostfix: 'structures',
  name: 'New costs structure',
  buttonSize: 'small',
  hasFullData: true,
  permissionToCheck: BUDGETING_READ,
});

export default useServiceCostsStructureRegistry;
